<p
  class="text-sm leading-5 font-medium pt-0.5 px-2 rounded-full inline-block"
  [ngClass]="{
    'text-(--text-primary)': status === 'Pending approval',
    'text-white': status === 'Rejected' || status === 'Accepted' || status === 'Active' || status == 'Inactive' || status == 'Suspended'
  }"
  [ngStyle]="{
    'background-color': status === 'Pending approval' ? 'var(--color-pending)' :
                        status === 'Rejected' || status == 'Suspended' ? 'var(--color-error)' :
                        status === 'Accepted' || status == 'Active' ? 'var(--color-accepted)' : 
                        status === 'Inactive' ? 'var(--color-muted)' : ''
  }"
>
  {{ status }}
</p>
